<template>
  <div>
    <footer class="footer" :class="this.footer=='footer-dark'?'footer-dark':''">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 footer-copyright text-center">
            <p class="mb-2">Copyright 2026 © Mercados Masivos - Desarrollo <a href="https://klatus.com">Klatus</a></p>
            <p>Patricio Sanz 1609 Torre B Piso 4, Alcaldía Benito Juárez ,Col. Del Valle Sur, CP 03104, CDMX</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { ref } from 'vue'
import json from '../data/menu'
import { storeToRefs } from 'pinia'
import { useLayoutStore } from '@/stores/layout'

export default {
  name: 'footerpage',
  setup() {
    const layoutStore = useLayoutStore()
    const { footer } = storeToRefs(layoutStore)

    const customizer = ref(false)
    const data = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(json))

    return {
      footer,
      customizer,
      data,
    }
  },
}
</script>

<style scoped>
  .footer {
    margin-left: 00px;
  }
</style>
